import { cn } from '@/utils/cn';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface AuthButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  variant?: 'primary' | 'ghost';
  children: ReactNode;
}

export function AuthButton({
  loading,
  variant = 'primary',
  children,
  disabled,
  className,
  type = 'button',
  ...props
}: AuthButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={cn(
        'btn w-full rounded-xl',
        variant === 'primary' ? 'btn-primary' : 'btn-ghost',
        className,
      )}
      {...props}
    >
      {loading ? (
        <span className="inline-flex items-center gap-2">
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
          Please wait…
        </span>
      ) : (
        children
      )}
    </button>
  );
}
